import { message } from "antd";
import { confirmDialog } from "@/utils/confirmDialog";

type ConfirmableOptions = {
    /** 状态在参数中的索引, 默认参数最后一项 */
    switchParamIndex?: number;
    /** 消息文本 */
    msgs: [string, string];
    /** 确认后的消息提示文本 */
    completedMsgs?: [string, string];
    /** 当参数为对象时, 状态参数的字段名 */
    switchParamFiled?: string;
};

type Decorator = (target: any, propertyKey: string, descriptor: PropertyDescriptor) => void;

// 导出 confirmWrapper 函数供其他地方使用
export const confirmWrapper = async (callBack: Function, msg: string, completedMsg?: string, title?: string) => {
    if (!(await confirmDialog(msg, title || "提示"))) return;

    const result = await callBack();

    /** 如果completedMsg不存在, 则截取'是否'后的两个字 */
    const completedMessage = completedMsg ?? /是否(.{2})/.exec(msg)?.at(1)?.replace(/^/, "已");
    completedMessage && message.success(completedMessage);

    return result;
};

function confirmable(options: ConfirmableOptions): Decorator;
function confirmable(msg: string, completedMsg?: string): Decorator;
function confirmable(msg: string | ConfirmableOptions, completedMsg?: string): Decorator {
    return (_target, _propertyKey, descriptor) => {
        const originMethod = descriptor.value as (...args: any[]) => Promise<any>;

        if (typeof msg === "string") {
            descriptor.value = async function (...args: any[]) {
                return await confirmWrapper(async () => await originMethod.apply(this, args), msg, completedMsg);
            };
        } else if (typeof msg === "object") {
            const options = msg;
            descriptor.value = async function (...args: any[]) {
                const switchParamIndex = options.switchParamIndex ?? args.length - 1;
                const switchParamValue = options.switchParamFiled
                    ? args[switchParamIndex][options.switchParamFiled]
                    : args[switchParamIndex];

                return await confirmWrapper(
                    async () => await originMethod.apply(this, args),
                    options.msgs[switchParamValue],
                    options.completedMsgs?.at(switchParamValue)
                );
            };
        }
    };
}

export { confirmable };
